import { Box, styled } from '@mui/material';
import { PropsWithChildren } from 'react';

const ActionBar = styled(Box)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.md, theme.spacingSizes.lg),
  borderTop: `1px solid ${theme.palette.borderColor.main}`,
}));

const PageActionBar: React.FC<PropsWithChildren> = ({ children }) => {
  return children ? <ActionBar>{children}</ActionBar> : null;
};

export default PageActionBar;
